export default "__VITE_ASSET__BsLyhuMP__"